module.exports = __webpack_public_path__ + "static/img/GuitarPlayer2020 (1).e57ccd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/GuitarPlayer2020 (1).png
// module id = bL1L
// module chunks = 12